import { Severity } from '@/api/domains/analyses';
import styles from '../ConfigurationForm.module.css';

interface PillSelectorProps {
  options: string[];
  value: Severity;
  onChange: (v: Severity) => void;
}

export const PillSelector = ({
  options,
  value,
  onChange
}: PillSelectorProps) => {
  return (
    <div className={styles.pillContainer}>
      {options.map((opt) => (
        <button
          key={opt}
          className={`${styles.pill} ${value === opt ? styles.pillActive : ''}`}
          onClick={() => onChange(opt as Severity)}
        >
          {opt}
        </button>
      ))}
    </div>
  );
};
